import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {isUserPremium} from '@Libraries/user.library';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './no-ai-images.module.scss';

interface NoAiImagesProps {
  children?: ReactElement;
}
export function NoAiImages({...props}: NoAiImagesProps): ReactElement {
  return (
    <div className="flex-column-align-center flex-content-center _full-height _full-width">
      <div className={`flex-center radius-round ${styles.iconContainer} ${isUserPremium() ? styles.aiColors : styles.premiumColors}`}>
        <Icon
          icon={isUserPremium() ? 'icon-ai-image' : 'icon-crown'}
          type={IconType.FLAT}
          size={IconSize.SIZE_ICON_32}
          shape={IconShape.NONE}
          className={isUserPremium() ? styles.aiColorBg : undefined}
        />
      </div>
      <Text
        className="spacing-p-t-5 -text-align-center"
        val={isUserPremium() ? window.i18next.t('pmwjs_no_ai_image_generate_one') : window.i18next.t('pmwjs_upgrade_account_to_generate_images')}
        size={TextSize.SMALL}
      />
      {props.children}
    </div>
  );
}
